import React, { useState, useEffect } from "react";
import "./Background.css";

function Background(props) {
  const [DivStyle, SetDivStyle] = useState({
    position: "absolute",
    left: "50vw",
    height: "50vw",
    width: "50vw",
    marginTop: "50px",
    zIndex: 1,
    backgroundColor: props.BackgroundColor
  });
  const [InnerWidth, SetInnerWidth] = useState(window.InnerWidth);
  const [backCover, setBackCover] = useState({});
  const [topCover, setTopCover] = useState({});
  const [rightCover, setRightCover] = useState({});
  const [bottomCover, setBottomCover] = useState({});
  const [leftCover, setLeftCover] = useState({});

  useEffect(() => {
    function CheckStyle() {
      //alert('change something')
      if (document.body.clientWidth > 600) {
        SetDivStyle({
          position: "absolute",
          left: document.body.clientWidth/2,
          height: document.body.clientWidth/2,
          width: document.body.clientWidth/2,
          top: "50px",
          backgroundColor: props.BackgroundColor,
          touchAction: "none",
          zIndex: 1
        });
        setLeftCover({
          position: "absolute",
          left: "0",
          top: "0",
          height: "100%",
          width: document.body.clientWidth / 2,
          backgroundColor: "#FFFFFF",
          // backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 2
        });
        setTopCover({
          position: "absolute",
          left: "335px",
          top: 0,
          height: "50px",
          width: document.body.clientWidth - 335 + "px",
          backgroundColor: "#FFFFFF",
          // backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 2
        });
        setBottomCover({
          position: "absolute",
          left: "335px",
          top: 50 + document.body.clientWidth / 2,
          width: document.body.clientWidth - 335,
          height: window.innerHeight - 50 - document.body.clientWidth / 2,
          backgroundColor: "#FFFFFF",
          // backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 2
        });
        setRightCover({});
      } 
      //if mobile
      else {
        SetDivStyle({
          position: "absolute",
          //margin: "0 auto",
          height: "300px",
          width: "300px",
          top: "10px",
          left: document.body.clientWidth / 2 - 150,
          backgroundColor: props.BackgroundColor,
          // backgroundImage: 'url:("https://api.caigoycreations.com/content/img/wood.png")',
          touchAction: "none",
          zIndex: 1
        });
        setBackCover({
          position: "absolute",
          width: "100%",
          height: document.body.clientWidth / 2 + 10 + "px",
          top: "0px",
          left: "0",
          backgroundColor: "#FFFFFF",
          backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 0
        });
        setTopCover({
          position: "absolute",
          left: "0",
          top: 0,
          height: "10px",
          width: "100%",
          backgroundColor: "#FFFFFF",
          // backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 2
        });
        setLeftCover({
          position: "absolute",
          left: "0",
          top: "0",
          height: "60%",
          width: document.body.clientWidth / 2 - 150 + "px",
          backgroundColor: "#FFFFFF",
          // backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 2
        });
        setRightCover({
          position: "absolute",
          left: document.body.clientWidth / 2 + 150,
          top: "0",
          height: "100%",
          width: document.body.clientWidth / 2 - 150,
          backgroundColor: "#FFFFFF",
          // backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 2
        });
        setBottomCover({
          position: "absolute",
          left: 0,
          top: 10 + 300,
          width: "100%",
          //height: window.innerHeight - 310,
          height: '100%',
          backgroundColor: "#FFFFFF",
          // backgroundImage: 'url("https://api.caigoycreations.com/content/img/wood.png")',
          zIndex: 2
        });
      }
    }
    CheckStyle();
    window.addEventListener("resize", CheckStyle);
  }, [props.BackgroundColor]);

  return (
    <div>
      <img
        src={props.product.PictureUrl1}
        style={{
          position: "absolute",
          left: DivStyle.left,
          top: DivStyle.top,
          height: DivStyle.height,
          marginLeft: DivStyle.marginLeft,
          zIndex: 1
        }}
      />

      <div style={DivStyle}></div>

      {!props.safetyLine &&
      <img
        src={props.product.PictureUrl2}
        style={{
          position: "absolute",
          left: DivStyle.left,
          top: DivStyle.top,
          height: DivStyle.height,
          marginLeft: DivStyle.marginLeft,
          //marginTop: DivStyle.marginTop,
          zIndex: 2
        }}
      />
      }
      {props.safetyLine &&
      <img
        src={props.product.PictureUrl3}
        style={{
          position: "absolute",
          left: DivStyle.left,
          top: DivStyle.top,
          height: DivStyle.height,
          marginLeft: DivStyle.marginLeft,
          //marginTop: DivStyle.marginTop,
          zIndex: 2
        }}
      />
      }

      {props.grid && (
        <img
          src={props.gridPic}
          style={{
            position: "absolute",
            left: DivStyle.left,
            top: DivStyle.top,
            height: DivStyle.height,
            width: DivStyle.height,
            marginLeft: DivStyle.marginLeft,
            //marginTop: DivStyle.marginTop,
            zIndex: 2
          }}
        />
      )}

      <div style={topCover} className="topCover"></div>
      <div style={rightCover} className="rightCover"></div>
      <div style={bottomCover} className="bottomCover"></div>
      <div style={leftCover} className="leftCover"></div>
    </div>
  );
}

export default Background;
